import React from "react";
import { useHistory } from "react-router";

import { WSPage } from "@wingspanhq/fe-component-library";
import {
  InvoiceStatus,
  InvoiceType
} from "@wingspanhq/payments/dist/interfaces";

import { WSQueries } from "../../../../query/WSQuery";
import { useQueryInvoicesFiltered } from "../../../../query/payments/queries";
import { useUserId } from "../../../../query/hooks/helpers";

import { PayrollLineItemsReportsDashboard } from "./PayrollLineItemsReportDashboard";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export const RoutePayrollLineItemsReport: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();

  const payrollRunsQuery = useQueryInvoicesFiltered({
    "labels.invoiceType": InvoiceType.Payroll,
    clientId: userId,
    status: InvoiceStatus.Paid
  });

  const queryCustomFieldsAll =
    queriesCustomFields.listCustomFields.useQueryAll();
  const customFields = (queryCustomFieldsAll.flatData ?? []).filter(
    customField =>
      customField.resourceType === CustomFieldResourceType.LINE_ITEM ||
      customField.resourceType === CustomFieldResourceType.PAYEE
  );

  return (
    <WSPage
      title="Payroll Line Items"
      breadcrumb={{
        label: "Back",
        onClick() {
          history.push("/member/reports");
        },
        icon: "arrow-left"
      }}
    >
      <WSQueries
        queries={{
          payrollLineItems: payrollRunsQuery,
          customFields: queryCustomFieldsAll
        }}
      >
        {({ payrollLineItems }) => (
          <PayrollLineItemsReportsDashboard
            payrollLineItemsData={payrollLineItems.data}
            customFieldsData={customFields}
          />
        )}
      </WSQueries>
    </WSPage>
  );
};
